export default __webpack_public_path__ + "static/media/send.f0e03455.svg";